module.exports = __webpack_public_path__ + "twilio-icon.png?ab4d93d5c37395c28b3af3ded9b174fd";